module.exports = __webpack_public_path__ + "img/blood_drop.e1b1cbfe.svg";